module.exports = __webpack_public_path__ + "static/media/order_type_tiktok.25df51a7.svg";